import i18next, { t } from "i18next";
import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";

const Timer = () => {
  const [timeLeft, setTimeLeft] = useState(900);
  const [visible, setVisible] = useState(false);
  const [windowWidth, setWindowWidth] = useState(0);

  const handleGetPlan = () => {
    const element = document.getElementById("get-plan-scroll");
    const element2 = document.getElementById("get-plan-scroll-new");
    windowWidth < 400 ? element2.scrollIntoView() : element.scrollIntoView();
  };

  useEffect(() => {
    const { innerWidth: width } = window;
    setWindowWidth(width);
    setTimeout(() => {
      setVisible(true);
    }, 100);
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTimeLeft((timeLeft) => {
        if (timeLeft === 1) {
          return 900;
        } else {
          return timeLeft - 1;
        }
      });
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;

  return (
    <div className={`timer-notification  ${visible ? "animate" : ""}`}>
      <div className="d-flex flex-column justify-content-between align-items-center">
        <p className="m-0 p-0" style={{ fontSize: "12px", fontWeight: "600" }}>
          {t("payment.discount_expires")}
        </p>
        <div className="d-flex flex-row">
          <div className="me-1 d-flex flex-column align-items-center">
            <h6 className="fw-bold p-0 m-0" style={{ fontSize: "30px" }}>
              {minutes < 10 ? `0${minutes}` : `${minutes}`}
            </h6>
            <p
              className="m-0 p-0 text-lowercase"
              style={{ fontSize: "12px", fontWeight: "600" }}
            >
              {t("payment.min")}
            </p>
          </div>
          <h6 className="fw-bold p-0 m-0" style={{ fontSize: "30px" }}>
            :
          </h6>
          <div className="ms-1 d-flex flex-column align-items-center">
            <h6 className="fw-bold p-0 m-0" style={{ fontSize: "30px" }}>
              {seconds < 10 ? `0${seconds}` : `${seconds}`}
            </h6>
            <p
              className="m-0 p-0 text-lowercase"
              style={{ fontSize: "12px", fontWeight: "600" }}
            >
              {t("payment.sec")}
            </p>
          </div>
        </div>
      </div>
      <Button
        onClick={handleGetPlan}
        className={`fw-semibold ${
          i18next.language === "en" ? "fs18" : "fs-16"
        } bgSecondary text-uppercase`}
        style={{
          height: "60px",
          borderRadius: "5px",
          width: "45%",
        }}
      >
        {t("payment.try_now")}
      </Button>
    </div>
  );
};

export default Timer;
